import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import getSearchText from './getSearchText';
import genKey from '../../utils/genKey';
export default function insertEntity(editor) {
  var regexp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var entityText = arguments.length > 2 ? arguments[2] : undefined;
  var entityType = arguments.length > 3 ? arguments[3] : undefined;
  var entityData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var entityId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : genKey();

  if (regexp) {
    var _getSearchText = getSearchText(regexp, editor.value),
        begin = _getSearchText.begin,
        end = _getSearchText.end;

    editor.moveAnchorTo(begin).moveFocusTo(end);
  }

  var selectedRange = editor.value.selection;
  return editor.insertInlineAtRange(selectedRange, {
    type: entityType,
    data: _objectSpread({}, entityData, {
      entityId: entityId
    }),
    nodes: [{
      object: 'text',
      text: entityText,
      marks: editor.value.marks
    }]
  }).focus();
}